import { Spin } from 'antd'
import React from 'react'
import styled from 'styled-components'
import Amount from '../Amount'
import { useCurrentInvoice } from './queries'

const AmountItem = styled.div`
  font-size: 32px;
  color: ${props => props.theme.colors.primary};
`

const AmountBlock = () => {
  const invoiceQuery = useCurrentInvoice()

  return (
    <Spin spinning={invoiceQuery.isLoading}>
      <AmountItem>
        {!!invoiceQuery.data?.unitID && (
          <Amount
            amount={invoiceQuery.data?.total}
            unit={invoiceQuery.data.unitID}
          />
        )}
      </AmountItem>
    </Spin>
  )
}

export default AmountBlock
